import { usePermissions } from "@/Composables";
import { adminNavigation, memberNavigation, repNavigation, vendorNavigation } from "@/Navigations";

const { is } = usePermissions();

export default function useNavigations() {
  let navigation = [];

  if (is("admin")) {
    ({ navigation } = adminNavigation());
  } else if (is("member")) {
    ({ navigation } = memberNavigation());
  } else if (is("vendor")) {
    ({ navigation } = vendorNavigation());
  } else if (is("rep")) {
    ({ navigation } = repNavigation());
  }

  const userNavigation = [
    { name: "Account Settings", route: `account-settings.profile.index` },
    ...(!is("admin") ? [{ name: "My Company Profile", route: `company-profile.index` }] : []),
    { name: "Sign out", route: "logout" },
  ];

  return {
    navigation,
    userNavigation,
  };
}
